import { useQuery } from '@tanstack/react-query';
import { getSession } from '../api/session/getSession';

export const useGetSession = () => {
  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: ['session'],
    queryFn: getSession,
  });

  return {
    initializing: isLoading || isFetching || isError,
    session: data,
  };
};
